import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import BASE_URL from '../../config/config';

const TicketCreado = () => {
    const { identificador } = useParams(); // Obtener el ID del ticket de los parámetros de la URL
    const [ticket, setTicket] = useState(null);
    const [cargando, setCargando] = useState(true);

    const token = localStorage.getItem("AuthToken");

    // Comprobar si el token está presente antes de intentar decodificarlo
    let tokenInfo = {};
    if (token) {
      tokenInfo = jwtDecode(token);
    }

    useEffect(() => {
        if (!document.querySelector('script[src="https://cdn.lordicon.com/lordicon.js"]')) {
            const script = document.createElement('script');
            script.src = 'https://cdn.lordicon.com/lordicon.js';
            document.head.appendChild(script);
        }
    }, []);

    useEffect(() => {
        const fetchTicket = async () => {
            try {
                const response = await fetch(`${BASE_URL}/ticket/${identificador}`);
                const data = await response.json();
                if (data.ticket.usuario_creador === tokenInfo.usuario || tokenInfo.role === 'admin' || tokenInfo.role === 'tecnico') {
                    setTicket(data.ticket);
                } else {
                    console.error('Error al obtener el ticket:', data.message);
                }
            } catch (error) {
                console.error('Error al obtener el ticket:', error);
            } finally {
                setCargando(false);
            }
        };
    
        fetchTicket();
    }, [identificador]);
    

    return (
        <main className='ticket-creado site-width'>
            <div className="bloque-ticket-creado">

                {ticket ? (() => {
                    const esGestionTecnico = ticket.abierto_por && ticket.abierto_por !== ticket.usuario_creador;
                    const esTecnicoOAdmin = tokenInfo.role === 'admin' || tokenInfo.role === 'tecnico';

                    if (esGestionTecnico) {
                        // Técnico/admin creó el ticket en nombre de otro usuario
                        return (
                            <>
                                <lord-icon
                                    src="https://cdn.lordicon.com/gvdzkarq.json"
                                    trigger="in"
                                    stroke="bold"
                                    colors="primary:#000000,secondary:#2c41a3"
                                    style={{width:'80px',height:'80px'}}>
                                </lord-icon>
                                <h2>Ticket creado correctamente</h2>
                                <p>Has abierto un ticket en nombre de <strong>@{ticket.usuario_creador}</strong>. El usuario podrá ver y gestionar su ticket desde su panel.</p>
                                <p className='identificador'>Identificador: {ticket.identificador}</p>
                                <p className='recordatorio'>El ticket ha quedado registrado y será atendido dentro de horario laboral.</p>
                                <Link to={`/ticket/${ticket.identificador}`} className='btn-ver-ticket'>Ver el ticket</Link>
                            </>
                        );
                    } else if (esTecnicoOAdmin) {
                        // Técnico/admin creó un ticket propio
                        return (
                            <>
                                <lord-icon
                                    src="https://cdn.lordicon.com/gvdzkarq.json"
                                    trigger="in"
                                    stroke="bold"
                                    colors="primary:#000000,secondary:#2c41a3"
                                    style={{width:'80px',height:'80px'}}>
                                </lord-icon>
                                <h2>Ticket creado correctamente</h2>
                                <p>El ticket ha sido registrado en el sistema y está disponible en el gestor de tickets.</p>
                                <p className='identificador'>Identificador: {ticket.identificador}</p>
                                <Link to={`/ticket/${ticket.identificador}`} className='btn-ver-ticket'>Ver ticket</Link>
                            </>
                        );
                    } else {
                        // Usuario normal
                        return (
                            <>
                                <lord-icon
                                    src="https://cdn.lordicon.com/gvdzkarq.json"
                                    trigger="in"
                                    stroke="bold"
                                    colors="primary:#000000,secondary:#2c41a3"
                                    style={{width:'80px',height:'80px'}}>
                                </lord-icon>
                                <h2>Gracias por enviar tu ticket</h2>
                                <p>
                                    En breve la asignaremos a un técnico para que pueda ayudarte.<br/>
                                    Trabajamos por orden de llegada dentro de nuestro horario laboral, pero haremos todo lo posible por atenderte cuanto antes.
                                </p>
                                <p className='identificador'>Identificador: {ticket.identificador}</p>
                                <Link to={`/ticket/${ticket.identificador}`} className='btn-ver-ticket'>Ver mi ticket</Link>
                            </>
                        );
                    }
                })() : cargando ? null : (
                    <>
                        <lord-icon
                            src="https://cdn.lordicon.com/wghpqwxd.json"
                            trigger="in"
                            stroke="bold"
                            colors="primary:#000000,secondary:#2c41a3"
                            style={{width:'80px',height:'80px'}}>
                        </lord-icon>
                        <h2>¡Oops! No tienes permisos</h2>
                        <p>Si crees que este mensaje es un error, <a href='tel:+34 856 901 276'>contáctanos</a>.</p>
                    </>
                )}
            </div>
        </main>
    );
};

export default TicketCreado;
